const segmentModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/fragments/segment-modal/segment-modal.html',
  controller: 'SegmentModalController',
};

angular
  .module('pis-tool.module')
  .component('segmentModal', segmentModal);
